module.exports = __webpack_public_path__ + "img/plus 1.ff213666.svg";